import { GlButton, GlDisclosureDropdownItem, GlFormGroup, GlFormInputGroup, GlTooltipDirective, GlToastMixin } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { InternalEvents } from '../../../tracking/index.js?vue3';
export default {
    name: 'CodeDropdownCloneItem',
    components: {
        GlDisclosureDropdownItem,
        GlFormGroup,
        GlFormInputGroup,
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin(),
        GlToastMixin
    ],
    props: {
        label: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        inputId: {
            type: String,
            required: false,
            default: ''
        },
        name: {
            type: String,
            required: false,
            default: null
        },
        testId: {
            type: String,
            required: true
        },
        tracking: {
            type: Object,
            required: false,
            default: ()=>({
                    action: null
                })
        }
    },
    methods: {
        onCopyUrl () {
            this.$toast.show(__('Copied'));
            this.trackCopyClick();
        },
        trackCopyClick () {
            const { action } = this.tracking;
            if (action) {
                this.trackEvent(action);
            }
        }
    },
    copyURLTooltip: __('Copy URL')
};
